export const validateReportDataResponse = (payload) => {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        throw new Error('The report response was not a valid object.');
    }

    if (typeof payload.success !== 'boolean') {
        throw new Error('The report response did not include a valid success state.');
    }

    if (payload.success && !Array.isArray(payload.data)) {
        throw new Error('The successful report response did not include row data.');
    }

    return payload;
};
